// extracted by mini-css-extract-plugin
export var dateLabel = "_4h-0";
export var dateLabelError = "_4h-1";
export var fullWidth = "_4h-2";
export var smaller = "_4h-3";